<template>
  <div id="categories" class="px-4">
    <category-list />
  </div>
</template>
<script>
import CategoryList from "@/components/category_management/CategoryList.vue";
export default {
  components: {
    CategoryList
  }
};
</script>
